import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { PermissionService } from 'app/core/auth/permission.service';
import { Permissions } from 'app/core/auth/permissions.constants';
import config from 'devextreme/core/config';
import { KeycloakService } from 'keycloak-angular';
import { KeyboardShortcutsModule, ShortcutInput } from 'ng-keyboard-shortcuts';
import { licenseKey } from './dextreme-license';
import { NavigationService } from './services/navigation.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, KeyboardShortcutsModule, TranslocoModule],
})
export class AppComponent implements OnInit {
    protected shortcuts: ShortcutInput[] = [];
    isAuthenticated = false;

    /**
     * Constructor
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _keycloakService: KeycloakService,
        private _translocoService: TranslocoService,
        private _navigationService: NavigationService,
        private _permissionService: PermissionService
    ) {
        this.isAuthenticated = this._keycloakService.isLoggedIn();
        this._fuseConfigService.config = {
            scheme: (localStorage.getItem('scheme') as 'dark' | 'light') || 'light',
        };

        this.devextremeLicense();

        document.documentElement.style.setProperty('--mat-menu-container-color', '#000000');
    }

    ngOnInit(): void {
        // Build shortcuts reactively — permissions may not be loaded yet at construction time
        this._permissionService.permissions$.subscribe(() => {
            this.createShortcuts();
        });
    }

    devextremeLicense(): void {
        config({ licenseKey });
    }

    createShortcuts() {
        this.shortcuts = [];

        // Admin
        if (this._permissionService.canView(Permissions.UserManagementViewList)) {
            this.shortcuts.push({
                key: 'ctrl + 0',
                label: this._translocoService.translate('application.shortcuts.main'),
                description: this._translocoService.translate('application.shortcuts.users_list_description'),
                preventDefault: true,
                command: () => this._navigationService.navigateToUsersList(),
            });
        }

        this.shortcuts.push({
            key: 'ctrl + 1',
            label: this._translocoService.translate('application.shortcuts.main'),
            description: this._translocoService.translate('application.shortcuts.dashboard_description'),
            preventDefault: true,
            command: () => this._navigationService.navigateToApplicationsDashboard(),
        });

        // Navigate to search anagrafica
        this.shortcuts.push({
            key: 'ctrl + shift + f',
            label: this._translocoService.translate('application.shortcuts.main'),
            description: this._translocoService.translate('application.shortcuts.search_anagrafica_description'),
            preventDefault: true,
            command: () => this._navigationService.navigateToSearchAnagrafica(),
        });
    }
}
